"use strict";

var ConstructionProjectAreaProgressLayer = function () {
  var loadLayerListenersForMap = function (map, mapLayers, mapId) {
    loadToggledListenerForMap(map, mapLayers, mapId);
    loadDataUpdatedListenerForMap(map, mapLayers, mapId);
    loadFiltersUpdatedListenerForMap(map, mapLayers, mapId);
  };

  var loadToggledListenerForMap = function (map, mapLayers, mapId) {
    MapFunctions.whenLayerToggled(
      mapId,
      "constructionProjectAreaProgress",
      function (isEnabled, sameSpatialFilter, sameView, sameGroup) {
        if (isEnabled) {
          if (
            mapLayers.constructionProjectAreaProgressLayer &&
            sameSpatialFilter &&
            sameView &&
            sameGroup
          ) {
            map.addLayer(mapLayers.constructionProjectAreaProgressLayer);
          } else {
            loadLayer();
          }
        } else {
          if (MapFunctions.mapHasLayer(map, mapLayers.constructionProjectAreaProgressLayer)) {
            map.removeLayer(mapLayers.constructionProjectAreaProgressLayer);
          }
        }
      },
    );
  };

  var loadLayer = function () {
    var mapId = Tree.get("mapId");
    var filters = Tree.get("filters");

    Tree.set(["layers", mapId, "constructionProjectAreaProgress", "isFetching"], true);
    ReportApiCalls.getConstructionProjectAreaProgress(filters, function (data) {
      if (data) {
        data.forEach((project) => {
          project.geom = project.projectAreaGeom;
        });
      }
      Tree.set(["layers", mapId, "constructionProjectAreaProgress", "isFetching"], false);
      Tree.set(["layers", mapId, "constructionProjectAreaProgress", "data"], data);
    });
  };

  var loadDataUpdatedListenerForMap = function (map, mapLayers, mapId) {
    MapFunctions.whenLayerDataUpdated(
      Tree,
      mapId,
      "constructionProjectAreaProgress",
      function (data) {
        const geoJsonData = CleanData.cleanGeoJSON(data);
        mapLayers.constructionProjectAreaProgressLayer = createLayerAndAddToMap(
          map,
          mapLayers,
          geoJsonData,
        );
      },
    );
  };

  var createLayerAndAddToMap = function (map, mapLayers, data) {
    if (mapLayers.constructionProjectAreaProgressLayer) {
      map.removeLayer(mapLayers.constructionProjectAreaProgressLayer);
    }
    mapLayers.constructionProjectAreaProgressLayer = createLayer(data);
    mapLayers.constructionProjectAreaProgressLayer.addTo(map);
    return mapLayers.constructionProjectAreaProgressLayer;
  };

  var createLayer = function (data) {
    return new (Layers.getLayers().ConstructionProjectAreaLayer)(data);
  };

  var loadFiltersUpdatedListenerForMap = function (map, mapLayers, mapId) {
    // @TODO: Update for construction filters
    Tree.watch({
      status: ["filters", "status"],
      ownership: ["filters", "ownership"],
      structureType: ["filters", "structureType"],
      dataSort: ["filters", "dataSort"],
    }).on("update", function (e) {
      if (
        MapFunctions.mapHasLayer(map, mapLayers.constructionProjectAreaProgressLayer) &&
        Tree.get("layers", mapId, "constructionProjectAreaProgress", "isEnabled")
      ) {
        loadLayer();
      }
    });
  };

  var getStyle = function (feature) {
    const color = ConstructionProjectStyles.getColorHex(feature.properties);
    return {
      color: color,
      fillOpacity: 0.8,
      fillColor: color,
      weight: 0,
    };
  };

  return {
    loadLayerListenersForMap,
    loadLayer,
    getStyle,
  };
};

module.exports = ConstructionProjectAreaProgressLayer();

const MapFunctions = require("../mapFunctions/mapFunctions");
const Tree = require("../../tree");
const ReportApiCalls = require("../reportApiCalls");
const CleanData = require("../mapFunctions/cleanData");
const Layers = require("../mapFunctions/layers");
const ConstructionProjectStyles = require("./constructionProjectStyles");
